import { Type } from "@angular/core";
import { IMeta } from "../i-meta";
//import { inherits } from "util";

export class WidgetMeta implements IMeta {
    public Name: string = '';
    public IsFave: boolean = false;
    public IsBeta: boolean = false;
    public IsChromeless: boolean = false;
    public IsCollapsed: boolean = false;
    public IsCollapsedAsFave: boolean = false;
    public IsModal: boolean = false;
    public SizeAsFave: number = 0; 
    public Size: number = 0; 
    public Data = {};
    public PageID: string = '';

    constructor(name: string) {
        this.Name = name;
        this.IsFave = false;
        this.IsBeta = false;
        this.IsChromeless = false;
        this.IsCollapsed = false;
        this.IsCollapsedAsFave = false;
        this.IsModal = false;
        this.Size = 12;
        this.SizeAsFave = 0;
        this.Data = {};
    }

    public copyFrom(widget: WidgetMeta) {
        if (!!widget) {
            this.IsFave = widget.IsFave;
            this.IsBeta = widget.IsBeta;
            this.IsChromeless = widget.IsChromeless;
            this.IsCollapsed = widget.IsCollapsed;
            this.IsCollapsedAsFave = widget.IsCollapsedAsFave;
            this.IsModal = widget.IsModal;
            this.Size = widget.Size;
            this.SizeAsFave = widget.SizeAsFave;
            this.Data = widget.Data;
            this.PageID = widget.PageID;
        }
    }
}

export class Widget {
    constructor(
        public module: string,
        public component: Type<any>,
        public meta: WidgetMeta,
    ) { }

    // Reach into the meta for size information, depending upon whether or not the widget is on the dashboard. 
    public get Size() : number {
        return (this.isOnDashboard) ? this.meta.SizeAsFave : this.meta.Size;
    }
    public set Size(value: number) {
        if (this.isOnDashboard) {
            this.meta.SizeAsFave = value;
        }
        else {
            this.meta.Size = value; 
        }
    }

    // Reach into the meta for size information
    public get IsFave(): boolean {
        return this.meta.IsFave; 
    }
    public set IsFave( value: boolean) {
        this.meta.IsFave = value;

        // Set the favorited size as the widget size if it's currently zero. 
        if ( value && ( this.meta.SizeAsFave == 0 ) ) {
            this.meta.SizeAsFave = this.meta.Size;
        }
    }

    public get IsModal(): boolean {
        return this.meta.IsModal;
    }

    public get IsBeta(): boolean {
        return this.meta.IsBeta;
    }
    public set IsBeta(value: boolean) {
        this.meta.IsBeta = value;
    }
    public get IsChromeless(): boolean {
        return this.meta.IsChromeless;
    }
    public set IsChromeless(value: boolean) {
        this.meta.IsChromeless = value;
    }
    public get IsCollapsed(): boolean {
        return (this.isOnDashboard) ? this.meta.IsCollapsedAsFave : this.meta.IsCollapsed;
    }
    public set IsCollapsed(value: boolean) {
        if (this.isOnDashboard) {
            this.meta.IsCollapsedAsFave = value;
        }
        else {
            this.meta.IsCollapsed = value;
        }
    }
    public get PageID(): string {
        return this.meta.PageID;
    }

    public get isOnDashboard(): boolean {
        return (this.module === 'DashboardComponent');
    }
}

export class ContentWidget extends Widget{
    constructor(
        public contentType: string,
        public module: string,
        public component: Type<any>,
        public meta: WidgetMeta,
    ) { super(module, component, meta) }
}
